/**
 * Resolve first/last name from user profile (supports legacy single `name` field).
 */
export function splitUserName(user) {
  if (!user) {
    return { firstName: '', lastName: '' };
  }
  const fn = (user.first_name || '').trim();
  const ln = (user.last_name || '').trim();
  if (fn || ln) {
    return { firstName: fn, lastName: ln };
  }
  const parts = (user.name || '').trim().split(/\s+/);
  if (!parts.length || !parts[0]) {
    return { firstName: '', lastName: '' };
  }
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
}
